export function cleanFontSize(html: string) {
  return html
    .replaceAll(/font-size:(.*?);/g, '')
    .replaceAll(/font-size:(.*?)"/g, '"'); // keep last double quote
}

export function convertFontSizeFromPxToRem(html: string) {
  // replace absolute font size (px) with relative font size (rem)
  return html.replaceAll(
    /font-size:\s*(\d+)\s*px/g,
    (match, $1) => `font-size: ${$1 / 16}rem`,
  );
}

export function cleanOpentechAttributes(node: Element) {
  node.removeAttribute('data-opentech-ux-zone-id');
  for (let i = 0; i < node.children.length; i++) {
    cleanOpentechAttributes(node.children[i]);
  }
}

export function unwrapParagraph(html: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  if (doc.body.children.length !== 1 || doc.body.children[0].tagName !== 'P') {
    return html;
  }
  const paragraphElement = doc.body.children[0];
  cleanOpentechAttributes(paragraphElement);
  return paragraphElement.innerHTML;
}

export function extractFirstStyleAttribute(html: string) {
  const styleRegex = /style="([^"]*)"/i;
  const match = html.match(styleRegex);

  if (match && match[1]) {
    return match[1];
  }

  return '';
}
